"use client";

import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function QuickConsultCard() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
      setIsVisible(scrollPercentage > 20);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <div id="quick-consult-card" className={`dark bg-background text-foreground fixed bottom-8 right-8 z-50 transition-all duration-300 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-[150%] opacity-0"}`} style={{
    backgroundColor: "#202836"
  }}>
      <Card className="w-80 shadow-strong border-muted">
        <CardHeader>
          <CardTitle className="text-xl font-semibold text-foreground">
            Konsultasi Cepat
          </CardTitle>
          <CardDescription className="text-base text-muted-foreground">
            Hubungi kami sekarang untuk konsultasi hukum
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Link to="https://wa.me/6282310335547" newTab>
            <Button className="whitespace-nowrap text-sm transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 w-full text-foreground-primary font-semibold py-3 px-6 rounded-md flex items-center justify-center gap-2 !bg-[hsl(112,71%,53%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover">
              <MessageCircle className="size-5" />
              Chat via WhatsApp
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>;
}